import ProductListItemComponent from "./ProductListItemComponent.tsx";
import IconPing from "../icons/IconPing.tsx";
import {imageMap} from "../../images/imageMap.ts";
import {formatAmountWithCurrency, formatAmountWithCurrencyOverPeriod} from "../../util/formatter.ts";
import IconTrophy from "../icons/IconTrophy.tsx";
import IconGears from "../icons/IconGears.tsx";
import IconCalendarCheck from "../icons/IconCalendarCheck.tsx";
import IconSpeedometerHigh from "../icons/IconSpeedometerHigh.tsx";
import IconServiceStatus from "../icons/IconServiceStatus.tsx";
import IconMonitorStroke from "../icons/IconMonitorStroke.tsx";
import IconGamingSmall from "../icons/IconGamingSmall.tsx";

export default function ProductListComponent() {
    return (
        <section className="products-wrapper">
            <ul className="products">

                <ProductListItemComponent
                    stamp={
                        <div className="mbb-stamp">
                            <span>5G</span>
                        </div>
                    }
                    speed_extra={
                        <span className="product-list-network mbb">Fri Data</span>
                    }
                    after_verb={"til"}
                    disclaimer_text={"Oprettelse og forsendelse"}
                    disclaimer_price={0}
                    extra_li_class={"product-list-item--discount mbb"}
                    pre_product_slogan={"Nyhed"}
                    heading={"5G-internet"}
                    first_time_string={"3 mdr."}
                    campaignPrice={199}
                    defaultPrice={279}
                    first_6_months_price={3 * 199 + 3 * 279}
                    up_to_mbit={"1000/100"}
                    image={{
                        alt: "En af markedets bedste 5G-routere, der leverer wifi-7 internet til hele familien.",
                        src: imageMap.products.product_item_router_mbb
                    }}
                    highlights={[
                        {
                            icon: IconTrophy,
                            text: "DK's bedste 5G-dækning"
                        },
                        {
                            icon: IconGears,
                            text: "Nem installation"
                        },
                        {
                            icon: IconCalendarCheck,
                            text: "Kom hurtigt online"
                        },
                        {
                            icon: IconSpeedometerHigh,
                            text: "Lynhurtigt internet"
                        },
                    ]}
                />

                <ProductListItemComponent
                    after_verb={"fra"}
                    disclaimer_text={"Tilslutning, oprettelse og forsendelse"}
                    disclaimer_price={0}
                    extra_li_class={"fiber"}
                    heading={"Bredbånd via fiber"}
                    first_time_string={"6 mdr."}
                    campaignPrice={99}
                    defaultPrice={299}
                    first_6_months_price={6 * 99}
                    up_to_mbit={"1000/1000"}
                    image={{
                        alt: "Hipers bedste fiber router, der kan levere lynhurtigt internet til hele hjemmet.",
                        src: imageMap.products.product_item_router_fiber
                    }}
                    highlights={[
                        {
                            icon: IconTrophy,
                            text: "Bedste forbindelse"
                        },
                        {
                            icon: IconServiceStatus,
                            text: "Mest stabile internet"
                        },
                        {
                            icon: IconSpeedometerHigh,
                            text: "Hurtigste hastighed"
                        },
                        {
                            icon: IconPing,
                            text: "Laveste ping"
                        },
                    ]}
                />

                <ProductListItemComponent
                    after_verb={"fra"}
                    disclaimer_text={"Oprettelse og forsendelse"}
                    disclaimer_price={0}
                    extra_li_class={"coax"}
                    heading={"Bredbånd via kabel-tv-stik"}
                    first_time_string={"6 mdr."}
                    campaignPrice={99}
                    defaultPrice={299}
                    first_6_months_price={6 * 99}
                    up_to_mbit={"1000/500"}
                    image={{
                        alt: "Hipers bedste kabel-tv router, der kan levere lynhurtigt internet til hele hjemmet.",
                        src: imageMap.products.product_item_router_coax
                    }}
                    highlights={[
                        {
                            icon: IconSpeedometerHigh,
                            text: "Lynhurtigt internet"
                        },
                        {
                            icon: IconServiceStatus,
                            text: "Stabilt internet"
                        },
                        {
                            icon: IconMonitorStroke,
                            text: "God til streaming"
                        },
                        {
                            icon: IconGamingSmall,
                            text: "God til gaming"
                        },
                    ]}
                />
            </ul>

            <div className="content content--wide">
                <p className="conditions">
                    Inkl. gratis oprettelse og lånerouter.
                    Min. pris i 6 mdr. fra {formatAmountWithCurrency(6 * 99)} Pris efter {6} mdr. fra {formatAmountWithCurrencyOverPeriod(299)} Tilbuddet gælder kun fiber og bredbånd via kabel-tv-stikket på TDC NET og Fibias netværk og på udvalgte adresser.
                    5G-internet hastighed er baseret på udendørs dækning og kan påvirkes af terræn og bebyggelse.
                </p>
            </div>
        </section>
    )
}
